import { Link } from "@tanstack/react-router"

function NotFound() {
	return (
		<div style={{ padding: 24 }}>
			<h1>404 — Not Found</h1>
			<p>The page you requested does not exist.</p>
			<Link to="/">Go to Home</Link>
		</div>
	)
}

export { NotFound }
